export function getBadgePrintRoute(path) {
    return `print/${path}`;
}
